import { Typography } from "antd";
import { MailOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

export const AboutPage = () => {
  return (
    <div
      className="w-full"
      style={{
        backgroundImage: "url('/assets/images/background-darker.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}>
      <section className="bg-dark w-full h-full md:h-[500px] py-18 px-6">
        <div className="container w-full max-w-6xl mx-auto">
          <Title
            level={1}
            className="font-azonix !font-normal text-primary tracking-wider pt-12 md:pt-24"
          >
            ABOUT ESTABROOK INC.
          </Title>
          <div className="max-w-6xl">
            <Paragraph
              className="text-xl text-light text-justify tracking-wider !leading-7 !mb-0"
            >
              Estabrook, Inc is a joint venture between a well-established excavation company in Truckee (Ruppert, Inc) as well as a long-standing Truckee family name (Estabrook). After 15 years of doing snow removal in the Truckee area we decided to start Estabrook. It is our goal to manage and run this operation of snow clearing in a similar way that customers have come to enjoy about our sister company Ruppert, Inc. Our aim is to have better tractors, more attentive operators, and clear less driveways per tractor than what has been deemed normal in the Truckee residential snow removal market.
            </Paragraph>
          </div>
        </div>
      </section>

      {/* Our Operations Section */}
      <section>
        <div className="container w-full max-w-6xl mx-auto px-6">
          <Title level={1} className="font-azonix !font-normal text-primary tracking-wider pt-12 !mb-12">
            OUR OPERATIONS
          </Title>

          {/* 1. TRACTORS - Text Left, Image Right */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-20 mb-20 items-center">
            <div>
              <Title level={4} className="font-azonix !font-normal text-white tracking-wider !mb-1">
                TRACTORS
              </Title>
              <Paragraph className="text-light text-base text-justify tracking-wider !leading-7 mb-4">
                We will start this season with more than sixteen "New Holland" brand tractors that will outperform any other tractor it is put up against. These machines run a total of 140-155 horsepower engines which is roughly 30 to 60 more horsepower than any of its competing tractors. These tractors have 98" wide snow blower boxes that are designed to not only process and throw the snow quickly, but will also scrape packed snow that has built up in the driveway. In high snowfall subdivisions such as Tahoe Donner, it is a simple math equation, More Horsepower = faster snow processing.
              </Paragraph>
            </div>
            <div>
              <img
                src="/assets/images/estabrook-truck.png"
                alt="Tractor in snow"
                className="w-full h-full md:h-80 object-cover"
              />
            </div>
          </div>

          {/* 2. OPERATORS - Image Left, Text Right */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-20 mb-20 items-center">
            <div className="md:order-last">
              <Title level={4} className="font-azonix !font-normal text-white tracking-wider !mb-1">
                OPERATORS
              </Title>
              <Paragraph className="text-light text-base text-justify tracking-wider !leading-7">
                This season, these tractors will have hand-picked, experienced operators who are not only used to doing snow removal such as this, but also have experience in running and operating this specific New Holland Tractor. We want to change the way you (the owner) interact with your specific operator. We feel that snow removal is a necessary evil in ways, no one wants to have to deal with it, and it's always messy. We encourage each homeowner to reach out to their specific operator and explain the quirks of their driveway, talk to the operator about their snow removal timeframes and needs.
              </Paragraph>
            </div>
            <div className="md:order-first">
              <img
                src="/assets/images/trucks-snow-about.png"
                alt="Snow removal operators"
                className="w-full h-55 md:h-80 object-cover"
              />
            </div>
          </div>

          {/* 3. DRIVEWAYS - Text Left, Image Right */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-20 mb-20 items-center">
            <div>
              <Title level={4} className="font-azonix !font-normal text-white tracking-wider !mb-1">
                DRIVEWAYS
              </Title>
              <Paragraph className="text-light text-base text-justify tracking-wider !leading-7">
                This snow season we will be taking as much as 1500 driveways into contract in the Tahoe Donner Area. Breaking these numbers down, that means an average of 80 driveways per route instead of 100+ that most have come to see as normal. This less amount of driveways, combined with competent operators and more efficient/newer tractors will inevitably equal a service that we hope each every homeowner will come to love.
              </Paragraph>
            </div>
            <div>
              <img
                src="/assets/images/truck-snow.png"
                alt="Snow removal driveways"
                className="w-full h-full md:h-80 object-cover"
              />
            </div>
          </div>
        </div>

        {/* 4. SNOW SYNC - Image Left, Text Right */}
        <div className="bg-primary-gradient">
          <div className="w-full max-w-6xl grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-20 items-center pb-20 px-6 mx-auto">
            <div>
              <Title level={4} className="font-azonix !font-normal text-white tracking-wider !mb-1">
                POWERED BY TECHNOLOGY
              </Title>
              <Paragraph className="text-light text-base text-justify tracking-wider !leading-7">
                To enable the communication with all of our customers, we are rolling out Snowsync. This is a custom-built app to manage all of our snow removal operations. With SnowSync, customers receive real-time updates, service notifications, and streamlined communication throughout every snow event.
              </Paragraph>
            </div>
            <div className="flex justify-center md:order-first">
              <img
                src="/assets/images/logo-snowsync.png"
                alt="Snow Sync Logo"
                className="w-3xs"
              />
            </div>
          </div>
        </div>
      </section>

        {/* Contact Section */}
        <section className="w-full bg-dark py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-2xl mx-auto bg-black p-8 text-center">
              <MailOutlined className="text-primary text-4xl mb-2" />
              <div className="font-azonix text-white text-xl uppercase tracking-wider mb-3">Email Us</div>
              <div className="text-secondary text-base tracking-wider mb-1">contact@estabrookinc.com</div>
              <div className="text-secondary text-base tracking-wider">We respond within 24 hours</div>
            </div>
          </div>
        </section>
    </div>
  );
};